export default "__VITE_ASSET__DPtLCCpC__"